import { Color } from '../../../../styles/Color';

export const getSecurityWaitTimeIconColor = (
	index: number,
	iconsLength: number,
	numberToFill: number,
) => {
	const reverseIndex = iconsLength - index; // Index from right to left
	if (reverseIndex <= numberToFill) {
		if (numberToFill === 2) return Color.Success;
		if (numberToFill === 3) return Color.Tertiary2;
		if (numberToFill === 4) return Color.Error;
	}
	return Color.Neutral4;
};
